import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import { createSentryPiniaPlugin } from '@sentry/vue';
import ClickOutside from './Directives/ClickOutside';

function getAttributes(el, prefix = null) {
  return Array.prototype.slice
    .call(el.attributes)
    .reduce((acc, attributeNode) => {
      let name = attributeNode.nodeName;
      let value = attributeNode.nodeValue.trim();
      if (prefix) {
        if (name.startsWith(prefix)) {
          name = name.replace(prefix, '');
        } else {
          return acc;
        }
      }

      // Formats liquid translation output to valid JSON for Vue props
      // eg: prop-terms="{{'cart.general' | t }}"
      if (value.charAt(0) === '{' && value.charAt(value.length - 1) === '}') {
        if (value.includes('=>')) {
          const formatted = value.replace(/=>/g, ':');
          value = formatted;
        }
        try {
          value = JSON.parse(value);
        } catch (error) {
          console.error(
            `Failed to parse JSON attribute "${name}":`,
            value,
            error
          );
          // Keep original string value if parsing fails
        }
      } else if (
        value.charAt(0) === '[' &&
        value.charAt(value.length - 1) === ']'
      ) {
        try {
          value = JSON.parse(value);
        } catch (error) {
          console.error(
            `Failed to parse JSON array attribute "${name}":`,
            value,
            error
          );
          // Keep original string value if parsing fails
        }
      }

      const notANumber = isNaN(parseInt(value));
      acc[name] = notANumber ? value : parseInt(value);
      return acc;
    }, {});
}

export const mountVue = (selector, rootComponent, parentSelector = false) => {
  const context = parentSelector || document;
  const el = context.querySelector(selector);
  let app;

  if (!el) {
    console.log("Element doesn't exist");
    return;
  }

  if (!!el.__vue_app__) {
    app = el.__vue_app__?._instance?.proxy;
  } else {
    const props = getAttributes(el, 'props-');
    app = createApp(rootComponent, props);
    app.directive('click-outside', ClickOutside);
    app.mount(el);
  }
};

export const unmountVue = (selector, parentSelector = false) => {
  const context = parentSelector || document;
  const el = context.querySelector(selector);
  let app;

  if (!el) {
    console.log("Element doesn't exist");
    return;
  }

  if (!!el.__vue_app__) {
    app = el.__vue_app__;
    app.unmount();
  } else return;
};

export const mountVueWithPinia = (
  selector,
  rootComponent,
  parentSelector = false
) => {
  const context = parentSelector || document;
  const el = context.querySelector(selector);

  if (!el) {
    console.log("Element doesn't exist");
    return;
  }

  const pinia = createPinia();
  const props = getAttributes(el, 'props-');
  const app = createApp(rootComponent, props);

  app.use(pinia);
  app.directive('click-outside', ClickOutside);
  app.mount(el);
};
